"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var FlagSet_1 = require("../../core/model/FlagSet");

var Baseline_1 = require("../model/Baseline");

var ZeroBaselineConverter_1 = require("./ZeroBaselineConverter");
/**
 * @author Radek Beran
 */


var ZeroBaselineConverterImpl =
/*#__PURE__*/
function (_ZeroBaselineConverte) {
  _inherits(ZeroBaselineConverterImpl, _ZeroBaselineConverte);

  function ZeroBaselineConverterImpl() {
    _classCallCheck(this, ZeroBaselineConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ZeroBaselineConverterImpl).apply(this, arguments));
  }

  _createClass(ZeroBaselineConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new Baseline_1.Baseline(conversions.documentToClassId(source), source.eId, conversions.toClassReferenceId(source.pId), conversions.toClassReferenceId(source.sId), conversions.toDate(source.d), 0, ZeroBaselineConverterImpl.EMPTY_FLAGS);
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        eId: source.externalId,
        pId: conversions.toDocumentReferenceId(source.productId),
        sId: conversions.toDocumentReferenceId(source.siteId),
        d: conversions.fromDate(source.date)
      });
      return result;
    }
  }]);

  return ZeroBaselineConverterImpl;
}(ZeroBaselineConverter_1.ZeroBaselineConverter);

exports.ZeroBaselineConverterImpl = ZeroBaselineConverterImpl;
ZeroBaselineConverterImpl.EMPTY_FLAGS = FlagSet_1.FlagSet.of(EntityStateFlag_1.EntityStateFlag);